<template>
  <div class="wrapper">
    <div class="top">
      <img :src="departmentIcon" />
      <div>
        <p>{{ department.deptName }}</p>
        <p>茂名市慢性疾病防治中心</p>
      </div>
    </div>
    <div class="content">
      <p>科室简介</p>
      <p class="ys">
        {{ department.descrip }}
      </p>
      <!-- <p class="ys">
        普通外科是琼海市人民医院最早设立的临床科室之一，医疗技术水平在岛东地区处于领先地位。
        科室环境优美，病房整洁温馨，开放床位50张。通过几代普外科专家的不懈努力，目前普外科已初步完成了亚专科的划分与建设。
        根据医院学科建设发展规划，普通外科以肝胆胰脾疝气、胃肠、肛肠疾病为学科专业发展方向，
        同时利用学科优势开展腹腔镜微创外科，开展普通外科所属疾病的腔镜外科治疗，促进微创外科的全面发展。
      </p>
      <p class="ys">
        现病区共有医护人员34人，其中医生14人，包括主任医师（教授）3人，副主任医师（副教授）3人，
        主治医师7人，住院医师1人，护士20人；科室高度重视人才培养和学科发展，与西京医院、
        广东省人民医院及海南省人民医院有长期的学术交流和人才培养计划，科室主治以上的医师均经过中国医学科学院肿瘤医院、
        华中科技大学同济医学院附属同济医院、南方医科大学附属南方医院、第三军医大学附属西南医院、
        第四军医大学附属西京医院、中山大学附属第六医院等国内著名三甲医院普通外科进修。
      </p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      department: {}
    }
  },
  created() {
    this.department = JSON.parse(sessionStorage.getItem("keyDepartment"));
  },
  computed: {
    departmentIcon() {
      if (this.department.iconurl) {
        return this.department.iconurl;
      }
      return require('@/assets/bg/bg_02.png');
    }
  },
  methods: {
    
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .top{
    padding: 26px 35px;
    margin-top: 10px;
    display: flex;
    flex-flow: row nowrap;
    background: #fff;
    >img{
      width: 72px;
      height: 72px;
    }
    >div{
      margin-left: 24px;
      flex: 1;
      >p:nth-child(1){
        margin: 8px 0px 12px;
        font-weight: bold;
        font-size: 17px;
      }
      >p:nth-child(2){
        font-size: 14px;
        color: #707070;
      }
    }
  }
  .content{
    margin-top: 10px;
    padding: 35px;
    background: #fff;
    >p:nth-child(1){
      font-size: 17px;
      font-weight: bold;
    }
    .ys{
      letter-spacing: 1px;
      margin-top: 24px;
      font-size: 14px;
      line-height: 24px;
      color: #707070;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/DepartmentDetails.vue